var map = {
	"./actions.ts": "./src/store/modules/actions.ts",
	"./apollo.js": "./src/store/modules/apollo.js",
	"./app.js": "./src/store/modules/app.js",
	"./disputes.ts": "./src/store/modules/disputes.ts",
	"./errorLog.js": "./src/store/modules/errorLog.js",
	"./invoices.ts": "./src/store/modules/invoices.ts",
	"./messages.ts": "./src/store/modules/messages.ts",
	"./permission.js": "./src/store/modules/permission.js",
	"./recipients.ts": "./src/store/modules/recipients.ts",
	"./risolto.js": "./src/store/modules/risolto.js",
	"./settings.js": "./src/store/modules/settings.js",
	"./tagsView.js": "./src/store/modules/tagsView.js",
	"./templates.ts": "./src/store/modules/templates.ts",
	"./user.js": "./src/store/modules/user.js",
	"./worklist.ts": "./src/store/modules/worklist.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/store/modules sync recursive \\.(js|ts)$";